import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { OffeneAuftraege } from './OffeneAuftraege';

export const OffeneAuftraegePrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const sortColumn = urlSearchParams.get('sortColumn') || 'groupByLabel';
    const sortDirection = urlSearchParams.get('sortDirection') === 'asc' ? 'asc' : 'desc';

    const betreuer = urlSearchParams.get('betreuer') ? parseInt(urlSearchParams.get('betreuer') || '0', 10) : undefined;
    const telBetreuer = urlSearchParams.get('telBetreuer')
        ? parseInt(urlSearchParams.get('telBetreuer') || '0', 10)
        : undefined;

    const status = urlSearchParams.get('status') ? parseInt(urlSearchParams.get('status') || '0', 10) : undefined;

    const berechnungsart = urlSearchParams.get('berechnungsart') === 'offen' ? 'offen' : 'status';

    return (
        <OffeneAuftraege
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            toggleSort={() => {}}
            betreuer={betreuer}
            telBetreuer={telBetreuer}
            status={status}
            berechnungsart={berechnungsart}
            printView
        />
    );
};
